import { Col, Row } from 'components/base';
import { Card } from 'design-system/base';
import type React from 'react';
import type { PropsWithChildren } from 'react';

import { BaseWrapper } from './Layout';

export const Wrapper: React.FC<PropsWithChildren> = ({ children }) => (
  <BaseWrapper>
    <Card>
      <Row>
        <Col flex={1}>{children}</Col>
      </Row>
    </Card>
  </BaseWrapper>
);
